export * from "./LabelClamp";
